/** Roles that may open the testing calendar (view). */
export const TESTING_CALENDAR_VIEW_ROLES = [
  'admin',
  'district_admin',
  'school_admin',
  'staff_view',
  'staff_edit',
  'staff_edit_docs',
  'admin_504',
  'sped_chair',
  'sped_chair_all',
  'case_manager',
  'case_manager_full',
  'speech_case_manager',
  'school_psych',
  'teacher',
  'teacher_full',
  'service_provider'
  // NOTE: paraeducator is intentionally NOT here — paras only see the Testing
  // Calendar / Testing Accommodations pages when granted the per-user
  // `testingAccess` flag (see canViewTestingCalendar fallback below).
]

/** Roles that may add/edit their own test sign-ups (teachers + case managers who teach). */
export const TESTING_CALENDAR_ADD_ROLES = [
  'teacher',
  'teacher_full',
  'case_manager',
  'case_manager_full',
  'speech_case_manager',
  'admin',
  'district_admin',
  'school_admin',
  'admin_504',
  'sped_chair',
  'sped_chair_all',
  'staff_view',
  'staff_edit',
  'staff_edit_docs',
  'school_psych'
]

export function canViewTestingCalendar(user) {
  if (!user?.role) return false
  if (TESTING_CALENDAR_VIEW_ROLES.includes(user.role)) return true
  return user.testingAccess === true
}

export function canAddTestingCalendar(user) {
  if (!user?.role) return false
  return TESTING_CALENDAR_ADD_ROLES.includes(user.role)
}

/** Coordinators: teacher filter, matrix view, sheet export. */
export const TESTING_CALENDAR_COORDINATOR_ROLES = [
  'admin',
  'district_admin',
  'school_admin',
  'admin_504',
  'sped_chair',
  'sped_chair_all',
  'staff_view',
  'staff_edit',
  'staff_edit_docs',
  'school_psych'
]

export function canCoordinateTestingCalendar(user) {
  if (!user?.role) return false
  return TESTING_CALENDAR_COORDINATOR_ROLES.includes(user.role)
}

/**
 * Roles passing Firestore hasFullReadAccess(), i.e. allowed to LIST
 * testing-flagged students (Period view headcounts). Anyone else needs the
 * per-user `testingAccess` flag (paraeducator proctors). Plain teachers, case
 * managers, and service providers are caseload-scoped and fail the rules —
 * they get the grid without counts rather than a permission error.
 */
export const TESTING_CALENDAR_COUNT_ROLES = [
  'admin',
  'district_admin',
  'school_admin',
  'admin_504',
  'sped_chair',
  'sped_chair_all',
  'staff_view',
  'staff_edit',
  'staff_edit_docs',
  'teacher_full',
  'case_manager_full',
  'school_psych'
]

export function canViewTestingCounts(user) {
  if (!user?.role) return false
  if (TESTING_CALENDAR_COUNT_ROLES.includes(user.role)) return true
  return user.testingAccess === true
}
